import moment from 'moment';
import 'moment-timezone';

import DropdownSelection from 'app/models/dropdown_selection';

export default DropdownSelection.extend({
  initialize() {
    const choices = [
      { option: '-08:00', readable: '-08:00 (PST)' },
      { option: '-07:00', readable: '-07:00 (PDT)' },
      { option: '-07:00', readable: '-07:00 (MST)' },
      { option: '-06:00', readable: '-06:00 (MDT)' },
      { option: '-06:00', readable: '-06:00 (CST)' },
      { option: '-05:00', readable: '-05:00 (CDT)' },
      { option: '-05:00', readable: '-05:00 (EST)' },
      { option: '-04:00', readable: '-04:00 (EDT)' },
      { option: '+00:00', readable: '+00:00 (UTC)' },
    ];

    const userTZ = moment.tz(moment.tz.guess());
    const choiceIdxUserTz = choices.findIndex(choice => choice.option === userTZ.format('Z'));

    if (choiceIdxUserTz !== -1) {
      this.set('currentChoice', choices[choiceIdxUserTz]);
    } else {
      choices.unshift({ option: userTZ.format('Z'), readable: `${userTZ.format('Z (z)')}` });
      this.set('currentChoice', choices[0]);
    }

    this.choices = choices;
    this.paramKey = 'utc_offset';
  },
});



// WEBPACK FOOTER //
// ./app/models/utc_offset_dropdown_selection.js